import { Deal } from '@/domain/entities/Offer';
import {
  DealVoteAction,
  DealDispatcherPayload,
  AllDealActions,
  BannerType,
  ShowToastProps,
  SaveDealAction,
  DealAction,
} from '@pelando/components';
import {
  EventCategory,
  GeneralDealEvents,
} from '../../../../domain/events/analytics';
import { emitTrackingEvent } from '../../../../infra/analytics/emitTrackingEvent';
import { RemoveVoteVariables } from '../../../../infra/api/votes/types/RemoveVote';
import { VoteVariables } from '../../../../infra/api/votes/types/Vote';
import { HEADER_HEIGHT } from '../../../components/Header/styles';
import { shareDealMobile, SourceShareDeal } from './services/share';

export type DealActionsHandler = {
  type: AllDealActions;
  payload: DealDispatcherPayload<AllDealActions>;
};

enum EventComponentName {
  CopyButton = 'copy_button',
}

type ActionHandlerMutationsParams = {
  action: DealActionsHandler;
  eventPrefix: string;
  onVote?: (payload: VoteVariables) => void;
  onRemoveVote?: (payload: RemoveVoteVariables) => void;
  showToast: (payload: ShowToastProps) => void;
  onSave?: (payload: { id: string }) => void;
  onRemoveSaved?: (payload: { id: string }) => void;
  deal?: Pick<Deal, 'id' | 'title' | 'kind' | 'status'>;
  toastAttributes?: {
    title: string;
    text: string;
  };
};

export const actionHandlerMutations = ({
  action,
  eventPrefix,
  onVote,
  onRemoveVote,
  showToast,
  onSave,
  onRemoveSaved,
  deal,
  toastAttributes,
}: ActionHandlerMutationsParams) => {
  switch (action.type) {
    case SaveDealAction.SAVE:
      onSave?.(action.payload as DealDispatcherPayload<SaveDealAction.SAVE>);

      break;
    case SaveDealAction.REMOVE:
      onRemoveSaved?.(
        action.payload as DealDispatcherPayload<SaveDealAction.REMOVE>
      );

      break;
    case DealVoteAction.VOTE:
      onVote?.(action.payload as DealDispatcherPayload<DealVoteAction.VOTE>);

      break;

    case DealVoteAction.REMOVE_VOTE:
      onRemoveVote?.(
        action.payload as DealDispatcherPayload<DealVoteAction.REMOVE_VOTE>
      );

      break;

    case DealAction.CLICK_COPY_COUPON:
      emitTrackingEvent({
        category: EventCategory.GeneralDeal,
        name: GeneralDealEvents.ClickToCopyCouponCode,
        extra: {
          component_name: `${eventPrefix}_${EventComponentName.CopyButton}`,
        },
      });
      showToast({
        titleText: toastAttributes?.title,
        topPosition: HEADER_HEIGHT,
        text: toastAttributes?.text,
        bannerType: BannerType.SUCCESS,
      });
      break;

    case DealAction.CLICK_TO_SHARE:
      emitTrackingEvent({
        category: EventCategory.GeneralDeal,
        name: GeneralDealEvents.ClickToShareDeal,
        extra: undefined,
      });
      if (deal) {
        shareDealMobile(deal, SourceShareDeal.deal);
      }

      break;

    default:
      break;
  }
};
